import { render, staticRenderFns } from "./Carte.vue?vue&type=template&id=424692f2&scoped=true&"
import script from "./Carte.vue?vue&type=script&lang=js&"
export * from "./Carte.vue?vue&type=script&lang=js&"
import style0 from "./Carte.vue?vue&type=style&index=0&id=424692f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424692f2",
  null
  
)

export default component.exports